import { itpRenderer } from '../../renderers';

export default (table) => {
  let name = 'fte_incentive_target_percentage';
  let visible_in_tooltip = /* Release 3.2 - 1.1 - Starts */(column, data, account) =>    
  (data.request_type === "businessexcellenceaward" || (data.request && data.request.request_type === "businessexcellenceaward")) ? false : true;
  /* Release 3.2 - 1.1 - Ends */;
  let renderer = (value, data, account, config) => itpRenderer('current', value, data, account, config);

  switch (table) {
    case 'editCompensation':
    case 'editOnetime':
    /* Release 3.2 - 1.1 - Starts */
    case 'editBEA':
    /* Release 3.2 - 1.1 - Ends */
    case 'rejectRequests':
    case 'approveRequests':
      case 'editInternalHire':
      name = 'request.for.fte_incentive_target_percentage';
      renderer = (value, data, account, config) => itpRenderer('current', value, data.request.for, account, config); 
      break;
    case 'myRequests':
    case 'requestsHistory':
    case 'approvedRequestHistory':
    case 'pendingRequests':
      name = 'for.fte_incentive_target_percentage';
      renderer = (value, data, account, config) => itpRenderer('current', value, data.for, account, config);
      break;
    default:
      break;
  }

  return { 
    name,
    label: "Incentive Target Percentage",
    tooltip_section: "Current",
    visible_in_tooltip,
    renderer
  };
};